import { render, staticRenderFns } from "./HistoryInfoTable.vue?vue&type=template&id=4fec4e98&scoped=true"
import script from "./HistoryInfoTable.vue?vue&type=script&lang=js"
export * from "./HistoryInfoTable.vue?vue&type=script&lang=js"
import style0 from "./HistoryInfoTable.vue?vue&type=style&index=0&id=4fec4e98&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fec4e98",
  null
  
)

export default component.exports